import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { ArrowLeft, Menu } from 'lucide-react';
import TipCustomerSegment from '../containers/tips/TipCustomerSegment';
import Button from './Button';
import BmcMobileMenu from './BmcMobileMenu';

export default function Header({
  title,
  subtitle,
  icon,
  tipLocales,
  locales,
  locales: { tips },
  className,
  menuItems,
  onMenuItemClick,
  mobileMenuHeader,
  componentIndex,
  rules,
  progress = 0,
  backPath,
}) {
  const [showTip, setShowTip] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const menuItemClick = (index) => {
    onMenuItemClick(index);
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <div className={classNames('bmc-page-header', className)}>
      {showTip && (
        <TipCustomerSegment
          onClose={() => setShowTip(false)}
          locales={tipLocales}
        />
      )}

      <BmcMobileMenu
        locales={locales}
        menuItems={menuItems}
        onMenuItemClick={menuItemClick}
        mobileMenuHeader={mobileMenuHeader}
        componentIndex={componentIndex}
        rules={rules}
        progress={progress}
        show={showMobileMenu}
        className={classNames({
          'bmc-menu--mobile-visible': showMobileMenu,
        })}
        onCloseClick={() => setShowMobileMenu(false)}
      />

      <div className="bmc-page-header-topbar">
        <div className="bmc-page-header-small-title mr-2">
          <div className="bmc-page-header-small-title-icon">
            {typeof icon === 'string' ? <i className={icon} /> : icon}
          </div>
          <span>{subtitle}</span>
        </div>

        <div className="bmc-page-header-mobile-actions md:hidden flex flex-row items-center gap-2">
          <Link to={backPath}>
            <Button aria-label="Back" variant="outline">
              <ArrowLeft className="w-5 h-auto" />
            </Button>
          </Link>

          <Button
            aria-label="Menu"
            variant="outline"
            onClick={() => setShowMobileMenu(true)}
          >
            <Menu className="w-5 h-auto" />
          </Button>
        </div>

        <div className="bmc-page-header-tips">
          <button
            className="bmc-button bmc-button--with-icon"
            onClick={() => setShowTip(true)}
          >
            <i className="icon-Hat" />
            <span>{tips}</span>
          </button>
        </div>
      </div>
      <div className="bmc-page-header-icon">
        {typeof icon === 'string' ? <i className={icon} /> : icon}
      </div>
      <h1 className="bmc-page-header-big-title">{title}</h1>
    </div>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  className: PropTypes.string,
  locales: PropTypes.object,
};
